import React from 'react'
import { Link } from 'react-router-dom'
import hotel from '../../../assets/images/hotels-img.jpg'
import flight from '../../../assets/images/flight.jpg'
import restaurents from '../../../assets/images/restaurants.jpg'
import car from '../../../assets/images/car-rentals.jpg'

export default function MiniRedirection() {
    const localSelectedCity = localStorage.getItem('selectedCity');
  return (
     <section className="section-equal-padding" style={{backgroundColor:'none'}}>
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
                    <Link to={`/hotel/${localSelectedCity}`} className="hotel_img_text"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <img src={hotel} alt="hotel" loading='lazy'/>
                        <div className="hotel_text">
                            <h2 className="hotels_heading mb-1">Hotels
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M5.83398 14.1667L14.1673 5.83337M14.1673 5.83337H5.83398M14.1673 5.83337V14.1667"
                                        stroke="#1A1A1A" strokeWidth="1.66667" strokeLinecap="round"
                                        strokeLinejoin="round" />
                                </svg>
                            </h2>
                            <p>Relax in handpicked hotels offering comfort, style, and prime locations in the heart of the city.</p>
                        </div>
                    </Link>
                </div>
                <div className="col-md-6 col-lg-3  mb-4 mb-lg-0">
                    <Link to={`/flight/${localSelectedCity}`} className="hotel_img_text"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <img src={flight} alt="flight" loading='lazy'/>
                        <div className="hotel_text">
                            <h2 className="hotels_heading mb-1">Flights
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M5.83398 14.1667L14.1673 5.83337M14.1673 5.83337H5.83398M14.1673 5.83337V14.1667"
                                        stroke="#1A1A1A" strokeWidth="1.66667" strokeLinecap="round"
                                        strokeLinejoin="round" />
                                </svg>
                            </h2>
                            <p>Find the best flight deals with seamless booking options to make your journey smooth and affordable.</p>
                        </div>
                    </Link>
                </div>
                <div className="col-md-6 col-lg-3 mb-4 mb-md-0">
                    <Link to={`/car-rental/${localSelectedCity}`} className="hotel_img_text"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <img src={car} alt="car" loading='lazy'/>
                        <div className="hotel_text">
                            <h2 className="hotels_heading mb-1">Car Rentals
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M5.83398 14.1667L14.1673 5.83337M14.1673 5.83337H5.83398M14.1673 5.83337V14.1667"
                                        stroke="#1A1A1A" strokeWidth="1.66667" strokeLinecap="round"
                                        strokeLinejoin="round" />
                                </svg>
                            </h2>
                            <p>Explore the city at your own pace with reliable car rentals tailored to your travel needs.</p>
                        </div>
                    </Link>
                </div>
                <div className="col-md-6 col-lg-3">
                    <Link to={`/restaurant/${localSelectedCity}`} className="hotel_img_text"
                        uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                        <img src={restaurents} alt="restaurents" loading='lazy'/>
                        <div className="hotel_text">
                            <h2 className="hotels_heading mb-1">Restaurants
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M5.83398 14.1667L14.1673 5.83337M14.1673 5.83337H5.83398M14.1673 5.83337V14.1667"
                                        stroke="#1A1A1A" strokeWidth="1.66667" strokeLinecap="round"
                                        strokeLinejoin="round" />
                                </svg>
                            </h2>
                           <p>Discover top-rated restaurants serving local flavors and global cuisines you’ll love.</p>
                        </div>
                    </Link>
                </div>
            </div>
        </div>
    </section>
  )
}
